import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import LogoScroller from "../components/LogoScroller";

const Partners = class extends React.Component {
  render() {
    return (
      <section className="home-about forcegrey">
        <div className="container">
          <div className="why">
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.h3
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(-50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  Our Partners
                </motion.h3>
              )}
            </InView>
          </div>
          <div className="aboutpartner">
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.p
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(-50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  We’re currently supporting some of most exciting brands in
                  Europe, from innovative start-ups, world leading gaming
                  studios to ground-breaking projects with Global Design
                  Agencies.
                </motion.p>
              )}
            </InView>
            <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
            <LogoScroller />

            </motion.div>
            )}
          </InView>
            <InView threshold={0.2}>
              {({ ref, inView }) => (
                <motion.p
                  ref={ref}
                  initial={{ opacity: 0, transform: "translate(-50px)" }}
                  animate={
                    inView
                      ? { opacity: 1, transform: "translate(0px)" }
                      : { opacity: 0 }
                  }
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    duration: 3,
                    delay: 0.25,
                  }}
                >
                  From seed stage start-ups to household names, our partners
                  model is aimed at helping those scaling up to hire talent
                  quickly and discreetly whilst being cost effective.
                </motion.p>
              )}
            </InView>
          </div>
          <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
              >
                <a href="mailto:info@weareopal.digital?subject=Let's work together" target="_blank" className="button-alt sizeit">
                  Join us
                </a>
              </motion.div>
            )}
          </InView>
        </div>
      </section>
    );
  }
};

export default Partners;
